import { Axios } from "./request";
import querystring from "query-string";
import { getTokens } from "../services/auth";

export const SIGN_IN = {
  post: (body) => {
    let newBody = {
      grant_type: "password",
      client_id: "SpaClient",
      client_secret: "SpaClientSecret",
      scope: "Main.Api openid offline_access",
      response_type: "code id_token",
      ...body,
    };
    return Axios.post(process.env.REACT_APP_AUTH_URL, querystring.stringify(newBody), {
      withToken: false,
      headers: {
        "content-type": "application/x-www-form-urlencoded",
      },
    });
  },
};

export const refreshToken = () => {
  const { refresh } = getTokens();
  let body = {
    grant_type: "refresh_token",
    client_id: "SpaClient",
    client_secret: "SpaClientSecret",
    scope: "Main.Api openid offline_access",
    refresh_token: refresh,
  };
  return Axios.post(process.env.REACT_APP_AUTH_URL, querystring.stringify(body), {
    withToken: true,
    headers: {
      "content-type": "application/x-www-form-urlencoded",
    },
  });
};
